export const slideLoaderMessages = [
  "While this slide is generating, you can go through the outline to see what's coming up and if any slide is ready.",
  'You can also create new versions of each slide or add new sections in the outline to further improve your generated presentation.',
  'Do you know that knowledge workers spend almost 50% of their time in creating business documents?',
  'Remember, the slide output is as good as the input. So, make sure to try out the slide narrative feature by clicking on the new version button.',
  'Get more control over your slides by using the custom builder to create a new slide version.',
  'Great presentations take time—Zynth is crafting your slides with precision!',
  'Once you have your slides ready, you can click on the finalize button for the ones you like and seamlessly share the final presentation through the share button.',
  'Use the export button to convert your Zynth presentation into completely editable Google Slides while staying completely in sync between the two platforms.',
  'While we’re working on your deck, have you thought about your next big idea?',
  'Building a professional deck that aligns with your brand—almost there!',
]

export const initialLoaderMessages = [
  'Gathering insights and visualizing your data for the perfect slides.',
  "Did you know? Zynth's AI uses tried-and-tested frameworks to create impactful presentations!",
  'By just waiting for a minute or two, you will be saving hours of content and design work.',
]
